export const MAIN_LOCATION = "Bulevardul Regina Elisabeta 33, Bucharest";
export const LOCATIONS = ["Anywhere", MAIN_LOCATION] as const;

export type BodyType =
  | "Compact"
  | "Coupe"
  | "Crossover"
  | "Premium Selection"
  | "Sedan"
  | "SUV";
export type FuelType = "CNG" | "Diesel" | "Electric" | "Petrol";
export type Transmission = "Automatic" | "Manual" | "Semi Automatic";

export interface Car {
  id: number;
  slug: string;
  name: string;
  brand: string;
  bodyType: BodyType;
  pricePerDay: number;
  transmission: Transmission;
  fuelType: FuelType;
  drive: "Left" | "Right";
  seats: number;
  year: number;
  rating: number;
  reviews: number;
  location: string;
  description: string;
  images: string[];
  popularity: number;
  /** Real chassis number. Left undefined on purpose — never fabricate VINs. */
  vin?: string;
  /** Set to true only for a car marketed as brand new (drives schema.org itemCondition). */
  isNew?: boolean;
}


// Fleet imported from carentals.ro (live listings, names, prices and photos).
export const cars: Car[] = [
  {
    id: 1,
    slug: "audi-a4-sporty-and-refined-premium-seda",
    name: "Audi A4: Sporty and Refined Premium Sedan",
    brand: "Audi",
    bodyType: "Sedan",
    pricePerDay: 111,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.7,
    reviews: 12,
    location: MAIN_LOCATION,
    description: "The Audi A4  offers a perfect blend of sportiness and refinement, featuring a sleek design, cutting-edge technology, and impressive performance. Whether you’re cruising through the city or taking a longer trip, the A4 delivers a smooth, responsive driving experience. Rent the Audi A4  from us today and enjoy premium comfort and style.",
    images: ["/__l5e/assets-v1/8ed8cf7c-9b43-48b5-9914-0948f13cb001/audi-a4-sporty-and-refined-premium-seda.png"],
    popularity: 100,
  },
  {
    id: 2,
    slug: "audi-q7-luxury-suv-with-space-and-advanced-technology",
    name: "Audi Q7: Luxury SUV with Space and Advanced Technology",
    brand: "Audi",
    bodyType: "SUV",
    pricePerDay: 129,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 7,
    year: 2019,
    rating: 4.9,
    reviews: 19,
    location: MAIN_LOCATION,
    description: "The Audi Q7 delivers a perfect combination of luxury, space, and cutting-edge technology. With a refined interior, powerful performance, and advanced safety features, this SUV is ideal for family trips or business travel. Rent the Audi Q7 from us today and experience premium comfort and versatility.",
    images: ["/__l5e/assets-v1/a5af6547-024a-442e-83fa-94809db55f62/audi-q7-luxury-suv-with-space-and-advanced-technology.png"],
    popularity: 99,
  },
  {
    id: 3,
    slug: "bmw-1-series-compact-hatchback-with-sporty-performance",
    name: "BMW 1 Series: Compact Hatchback with Sporty Performance",
    brand: "BMW",
    bodyType: "SUV",
    pricePerDay: 62,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.7,
    reviews: 26,
    location: MAIN_LOCATION,
    description: "The BMW 1 Series combines sporty handling, modern design, and premium features in a compact hatchback. Ideal for urban driving, it offers a comfortable interior and responsive performance, making every journey enjoyable. Rent the BMW 1 Series from us today and experience the thrill of driving a luxury compact.",
    images: ["/__l5e/assets-v1/e2632ce1-2f00-4800-83b5-4e4884d6aa1e/bmw-1-series-compact-hatchback-with-sporty-performance.png"],
    popularity: 98,
  },
  {
    id: 4,
    slug: "bmw-3-series-sporty-and-elegant-sedan",
    name: "BMW 3 Series: Sporty and Elegant Sedan",
    brand: "BMW",
    bodyType: "Sedan",
    pricePerDay: 111,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.7,
    reviews: 33,
    location: MAIN_LOCATION,
    description: "The BMW 3 Series offers a perfect balance of sportiness and elegance, with responsive handling, advanced technology, and a refined interior. Ideal for both city commutes and long drives, this sedan delivers an exceptional driving experience. Rent the BMW 3 Series from us and enjoy premium comfort and performance.",
    images: ["/__l5e/assets-v1/ba63bb76-76ee-411f-aaba-5e61e379da00/bmw-3-series-sporty-and-elegant-sedan.png"],
    popularity: 97,
  },
  {
    id: 5,
    slug: "bmw-5-series-luxury-sedan-with-superior-performance",
    name: "BMW 5 Series: Luxury Sedan with Superior Performance",
    brand: "BMW",
    bodyType: "Sedan",
    pricePerDay: 155,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.8,
    reviews: 40,
    location: MAIN_LOCATION,
    description: "The BMW 5 Series is a luxury sedan that blends refined elegance with superior performance. Featuring a sophisticated design, advanced technology, and a smooth, powerful drive, it’s perfect for both business and leisure. Rent the BMW 5 Series from us and experience unparalleled comfort and style.",
    images: ["/__l5e/assets-v1/07dd08ef-dd14-4538-aaf5-49722cba4d17/bmw-5-series-luxury-sedan-with-superior-performance.png"],
    popularity: 96,
  },
  {
    id: 6,
    slug: "bmw-5-series-plug-in-hybrid-luxury-sedan-with-advanced-efficiency",
    name: "BMW 5 Series Plug-In Hybrid: Luxury Sedan with Advanced Efficiency",
    brand: "BMW",
    bodyType: "Sedan",
    pricePerDay: 155,
    transmission: "Automatic",
    fuelType: "Electric",
    drive: "Left",
    seats: 5,
    year: 2020,
    rating: 4.9,
    reviews: 47,
    location: MAIN_LOCATION,
    description: "Experience the BMW 5 Series Plug-In Hybrid, a luxury sedan that combines powerful performance with cutting-edge hybrid technology. Enjoy a smooth, efficient ride with the flexibility of electric and gasoline power. Perfect for eco-conscious drivers seeking premium comfort and reduced emissions. Rent the BMW 5 Series Plug-In Hybrid from us today and drive with style and sustainability.",
    images: ["/__l5e/assets-v1/9b95c6c1-0259-418a-b0fb-7cf877cb9e98/bmw-5-series-plug-in-hybrid-luxury-sedan-with-advanced-efficiency.png"],
    popularity: 95,
  },
  {
    id: 7,
    slug: "bmw-7-series-ultimate-luxury-sedan-with-advanced-technology",
    name: "BMW 7 Series: Ultimate Luxury Sedan with Advanced Technology",
    brand: "BMW",
    bodyType: "Sedan",
    pricePerDay: 155,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2020,
    rating: 5.0,
    reviews: 14,
    location: MAIN_LOCATION,
    description: "The BMW 7 Series is the pinnacle of luxury sedans, offering unparalleled comfort, cutting-edge technology, and powerful performance. With a spacious, high-end interior and smooth handling, it’s the perfect choice for business or leisure. Rent the BMW 7 Series from us today and experience sophistication at its finest.",
    images: ["/__l5e/assets-v1/f17bdee2-2372-45a0-83c1-7b02e818a6d5/bmw-7-series-ultimate-luxury-sedan-with-advanced-technology.png"],
    popularity: 94,
  },
  {
    id: 8,
    slug: "bmw-x1-compact-suv-with-dynamic-performance",
    name: "BMW X1: Compact SUV with Dynamic Performance",
    brand: "BMW",
    bodyType: "SUV",
    pricePerDay: 89,
    transmission: "Semi Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.5,
    reviews: 21,
    location: MAIN_LOCATION,
    description: "The BMW X1 is a compact SUV that offers dynamic performance, agile handling, and a luxurious interior. Perfect for both city driving and weekend getaways, it combines versatility with premium comfort. Rent the BMW X1 from us and experience the perfect blend of style and performance.",
    images: ["/__l5e/assets-v1/f598b920-5106-4c89-826d-cb2f8d7bcf0e/bmw-x1-compact-suv-with-dynamic-performance.png"],
    popularity: 93,
  },
  {
    id: 9,
    slug: "bmw-x1-compact-suv-with-versatile-performance",
    name: "BMW X1: Compact SUV with Versatile Performance",
    brand: "BMW",
    bodyType: "SUV",
    pricePerDay: 89,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.6,
    reviews: 28,
    location: MAIN_LOCATION,
    description: "The BMW X1 delivers versatile performance in a compact SUV package, offering a smooth ride, premium interior, and excellent handling. Ideal for urban drives or longer journeys, it combines practicality with luxury. Rent the BMW X1 from us and enjoy comfort and style on every trip.",
    images: ["/__l5e/assets-v1/175c69b0-c811-4877-8351-dcc91c68e328/bmw-x1-compact-suv-with-versatile-performance.png"],
    popularity: 92,
  },
  {
    id: 10,
    slug: "bmw-x2-stylish-compact-suv-with-dynamic-performance",
    name: "BMW X2: Stylish Compact SUV with Dynamic Performance",
    brand: "BMW",
    bodyType: "SUV",
    pricePerDay: 89,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.9,
    reviews: 35,
    location: MAIN_LOCATION,
    description: "The BMW X2 2018 offers a perfect blend of sporty design and practicality. With its compact dimensions, agile handling, and luxurious interior, this SUV is ideal for urban adventures and weekend getaways. Rent the BMW X2 from us today and enjoy a unique driving experience with premium features.",
    images: ["/__l5e/assets-v1/afc19b9a-2c41-4c66-b30a-da32c16c4afe/bmw-x2-stylish-compact-suv-with-dynamic-performance.png"],
    popularity: 91,
  },
  {
    id: 11,
    slug: "bmw-x3-compact-suv-with-exceptional-performance",
    name: "BMW X3: Compact SUV with Exceptional Performance",
    brand: "BMW",
    bodyType: "Crossover",
    pricePerDay: 103,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.7,
    reviews: 42,
    location: MAIN_LOCATION,
    description: "The BMW X3 delivers a smooth blend of performance and practicality, featuring a refined interior, advanced technology, and responsive handling. Perfect for both city driving and weekend adventures, this compact SUV offers premium comfort and versatility. Rent the BMW X3 from us today and enjoy a dynamic driving experience.",
    images: ["/__l5e/assets-v1/9991ec31-7757-474a-bccd-4ea81f31a639/bmw-x3-compact-suv-with-exceptional-performance.png"],
    popularity: 90,
  },
  {
    id: 12,
    slug: "bmw-x3-versatile-suv-with-dynamic-performance",
    name: "BMW X3: Versatile SUV with Dynamic Performance",
    brand: "BMW",
    bodyType: "SUV",
    pricePerDay: 103,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.6,
    reviews: 49,
    location: MAIN_LOCATION,
    description: "The BMW X3 offers a perfect combination of versatility, performance, and luxury. With its powerful engine, advanced technology, and spacious interior, this SUV is ideal for both city driving and adventurous getaways. Rent the BMW X3 from us today and experience premium comfort and dynamic handling.",
    images: ["/__l5e/assets-v1/210ded5b-655a-4563-8dcd-4edabd59448f/bmw-x3-versatile-suv-with-dynamic-performance.png"],
    popularity: 89,
  },
  {
    id: 13,
    slug: "bmw-x4-sporty-suv-with-sleek-design-and-dynamic-performance",
    name: "BMW X4: Sporty SUV with Sleek Design and Dynamic Performance",
    brand: "BMW",
    bodyType: "SUV",
    pricePerDay: 103,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.8,
    reviews: 16,
    location: MAIN_LOCATION,
    description: "The BMW X4 offers a unique blend of sporty design and SUV versatility. With its coupe-like styling, advanced technology, and powerful engine, it provides a thrilling driving experience without compromising on comfort. Rent the BMW X4 from us today and enjoy dynamic performance with premium features.",
    images: ["/__l5e/assets-v1/4931a3a6-81e2-400c-97f4-b0ad94ec2251/bmw-x4-sporty-suv-with-sleek-design-and-dynamic-performance.png"],
    popularity: 88,
  },
  {
    id: 14,
    slug: "bmw-x5-luxury-suv-with-powerful-performance",
    name: "BMW X5: Luxury SUV with Powerful Performance",
    brand: "BMW",
    bodyType: "SUV",
    pricePerDay: 129,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2020,
    rating: 4.9,
    reviews: 23,
    location: MAIN_LOCATION,
    description: "The BMW X5 combines luxury, space, and powerful performance, offering a premium driving experience in a versatile SUV. With advanced technology, a spacious interior, and exceptional handling, it’s perfect for both city commutes and long-distance travel. Rent the BMW X5 from us today and enjoy comfort, style, and power.",
    images: ["/__l5e/assets-v1/228a63e1-cfe8-4293-a6b1-acfa1f81a041/bmw-x5-luxury-suv-with-powerful-performance.png"],
    popularity: 87,
  },
  {
    id: 15,
    slug: "bmw-x6-sporty-luxury-suv-with-dynamic-performance",
    name: "BMW X6: Sporty Luxury SUV with Dynamic Performance",
    brand: "BMW",
    bodyType: "SUV",
    pricePerDay: 129,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2020,
    rating: 5.0,
    reviews: 30,
    location: MAIN_LOCATION,
    description: "The BMW X6 combines sporty aesthetics with luxury and versatility, offering a powerful performance and an upscale interior. With advanced technology, ample space, and a commanding presence on the road, this SUV is perfect for those seeking a thrilling driving experience. Rent the BMW X6 from us today and elevate your journey.",
    images: ["/__l5e/assets-v1/d19d57e0-08db-4189-958a-a9e7cfef9a09/bmw-x6-sporty-luxury-suv-with-dynamic-performance.png"],
    popularity: 86,
  },
  {
    id: 16,
    slug: "dacia-logan-affordable-and-reliable-sedan-with-modern-comfort",
    name: "Dacia Logan: Affordable and Reliable Sedan with Modern Comfort",
    brand: "Dacia",
    bodyType: "Sedan",
    pricePerDay: 44,
    transmission: "Manual",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2020,
    rating: 4.4,
    reviews: 37,
    location: MAIN_LOCATION,
    description: "The Dacia Logan combines practicality with modern features, offering a spacious interior and excellent fuel efficiency. Ideal for both city driving and long-distance travel, this sedan provides a comfortable and reliable ride at an affordable price. Rent the Dacia Logan from us today and enjoy dependable performance.",
    images: ["/__l5e/assets-v1/88ce6e80-5bc0-4410-9a9a-2f5287a1499b/dacia-logan-affordable-and-reliable-sedan-with-modern-comfort.png"],
    popularity: 85,
  },
  {
    id: 17,
    slug: "ford-fiesta-compact-and-efficient-car-for-city-driving",
    name: "Ford Fiesta: Compact and Efficient Car for City Driving",
    brand: "Ford",
    bodyType: "Compact",
    pricePerDay: 44,
    transmission: "Manual",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.5,
    reviews: 44,
    location: MAIN_LOCATION,
    description: "The Ford Fiesta is a compact car that combines agility, fuel efficiency, and modern features. Ideal for city driving, it offers a comfortable interior and responsive handling, making every trip enjoyable. Rent the Ford Fiesta from us today and experience easy, efficient driving.",
    images: ["/__l5e/assets-v1/461a4736-3dc1-4080-9623-e1f05ec56322/ford-fiesta-compact-and-efficient-car-for-city-driving.png"],
    popularity: 84,
  },
  {
    id: 18,
    slug: "ford-kuga-spacious-suv-with-comfort-and-performance",
    name: "Ford Kuga: Spacious SUV with Comfort and Performance",
    brand: "Ford",
    bodyType: "SUV",
    pricePerDay: 89,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.5,
    reviews: 51,
    location: MAIN_LOCATION,
    description: "The Ford Kuga offers the perfect blend of comfort, space, and reliable performance. With advanced technology, a roomy interior, and smooth handling, this SUV is ideal for both city drives and long trips. Rent the Ford Kuga from us today and enjoy a versatile driving experience with premium features.",
    images: ["/__l5e/assets-v1/4e4e33a2-ff02-4815-8f7b-1634ee78b51b/ford-kuga-spacious-suv-with-comfort-and-performance.png"],
    popularity: 83,
  },
  {
    id: 19,
    slug: "mercedes-a-class-stylish-compact-car-with-premium-features",
    name: "Mercedes A-Class: Stylish Compact Car with Premium Features",
    brand: "Mercedes",
    bodyType: "Compact",
    pricePerDay: 62,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.7,
    reviews: 18,
    location: MAIN_LOCATION,
    description: "The Mercedes A-Class combines luxury, advanced technology, and dynamic performance in a sleek compact car. With its refined interior and cutting-edge features, it’s perfect for both city drives and longer trips. Rent the Mercedes A-Class from us today and enjoy a premium driving experience.",
    images: ["/__l5e/assets-v1/b179cf1a-3b71-4511-b2e0-eec3ee8e7412/mercedes-a-class-stylish-compact-car-with-premium-features.png"],
    popularity: 82,
  },
  {
    id: 20,
    slug: "mercedes-c-class-premium-sedan-with-style-and-performance",
    name: "Mercedes C-Class: Premium Sedan with Style and Performance",
    brand: "Mercedes",
    bodyType: "Sedan",
    pricePerDay: 111,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.8,
    reviews: 25,
    location: MAIN_LOCATION,
    description: "The Mercedes C-Class is a premium sedan that combines sleek design, advanced technology, and exceptional performance. Whether for city driving or long trips, this car offers comfort, elegance, and power in every journey. Rent the Mercedes C-Class  from us today and enjoy a refined driving experience.",
    images: ["/__l5e/assets-v1/be31247e-0461-4a39-ac1d-5e2ad1c1da93/mercedes-c-class-premium-sedan-with-style-and-performance.png"],
    popularity: 81,
  },
  {
    id: 21,
    slug: "mercedes-e-class-elegant-sedan-with-advanced-features",
    name: "Mercedes E-Class: Elegant Sedan with Advanced Features",
    brand: "Mercedes",
    bodyType: "Sedan",
    pricePerDay: 155,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.8,
    reviews: 32,
    location: MAIN_LOCATION,
    description: "The Mercedes E-Class combines luxury, comfort, and cutting-edge technology in a sophisticated sedan. With a spacious interior, refined design, and powerful performance, it’s perfect for both business and leisure trips. Rent the Mercedes E-Class from us today and experience an exceptional driving experience.",
    images: ["/__l5e/assets-v1/1e751be5-bfb5-4042-acc8-9999168d5d0f/mercedes-e-class-elegant-sedan-with-advanced-features.png"],
    popularity: 80,
  },
  {
    id: 22,
    slug: "mercedes-gle-amg-coupe-high-performance-premium-suv",
    name: "Mercedes GLE AMG Coupe: High-Performance Premium SUV",
    brand: "Mercedes",
    bodyType: "Coupe",
    pricePerDay: 129,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2020,
    rating: 5.0,
    reviews: 39,
    location: MAIN_LOCATION,
    description: "The Mercedes GLE AMG Coupe delivers high-performance in a sleek, premium SUV package. With dynamic handling and striking design, it offers an exhilarating driving experience. Rent it now and enjoy unparalleled style and power.",
    images: ["/__l5e/assets-v1/ec33307d-5ec8-4a63-8b05-42d71ae651a8/mercedes-gle-amg-coupe-high-performance-premium-suv.png"],
    popularity: 79,
  },
  {
    id: 23,
    slug: "mercedes-gle-premium-suv-with-advanced-performance",
    name: "Mercedes GLE: Premium SUV with Advanced Performance",
    brand: "Mercedes",
    bodyType: "SUV",
    pricePerDay: 129,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2020,
    rating: 4.9,
    reviews: 46,
    location: MAIN_LOCATION,
    description: "Experience the Mercedes GLE , a premium SUV offering advanced performance, comfort, and cutting-edge technology. Perfect for any journey, it combines power and style effortlessly. Rent it from us today and enjoy unbeatable rates.",
    images: ["/__l5e/assets-v1/6883bb3a-c018-42a0-9b02-956935ed7029/mercedes-gle-premium-suv-with-advanced-performance.png"],
    popularity: 78,
  },
  {
    id: 24,
    slug: "subaru-impreza-compact-car-with-all-wheel-drive-and-reliability",
    name: "Subaru Impreza: Compact Car with All-Wheel Drive and Reliability",
    brand: "Subaru",
    bodyType: "Sedan",
    pricePerDay: 62,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.6,
    reviews: 13,
    location: MAIN_LOCATION,
    description: "The Subaru Impreza offers a perfect mix of reliability, fuel efficiency, and all-wheel drive capability. With its sleek design, advanced safety features, and comfortable interior, it’s ideal for both city driving and outdoor adventures. Rent the Subaru Impreza from us today and enjoy a smooth, dependable ride.",
    images: ["/__l5e/assets-v1/235c9e91-f2bc-43d6-88b8-47bc6216b635/subaru-impreza-compact-car-with-all-wheel-drive-and-reliability.png"],
    popularity: 77,
  },
  {
    id: 25,
    slug: "volkswagen-jetta-sleek-sedan-with-comfort-and-efficiency",
    name: "Volkswagen Jetta: Sleek Sedan with Comfort and Efficiency",
    brand: "Volkswagen",
    bodyType: "Sedan",
    pricePerDay: 62,
    transmission: "Automatic",
    fuelType: "Petrol",
    drive: "Left",
    seats: 5,
    year: 2018,
    rating: 4.5,
    reviews: 20,
    location: MAIN_LOCATION,
    description: "The Volkswagen Jetta offers a perfect balance of style, comfort, and fuel efficiency. With its modern design, advanced features, and smooth performance, this sedan is ideal for both city driving and longer journeys. Rent the Volkswagen Jetta from us today and enjoy a refined driving experience.",
    images: ["/__l5e/assets-v1/dda858bf-ee58-4672-a035-b1a7b5b59a1f/volkswagen-jetta-sleek-sedan-with-comfort-and-efficiency.png"],
    popularity: 76,
  },
  {
    id: 26,
    slug: "volkswagen-passat-spacious-sedan-with-comfort-and-efficiency",
    name: "Volkswagen Passat: Spacious Sedan with Comfort and Efficiency",
    brand: "Volkswagen",
    bodyType: "Sedan",
    pricePerDay: 89,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.6,
    reviews: 27,
    location: MAIN_LOCATION,
    description: "The Volkswagen Passat 2018 offers a perfect blend of spaciousness, comfort, and fuel efficiency. With its refined interior, advanced technology, and smooth handling, this sedan is ideal for both family trips and daily commutes. Rent the Volkswagen Passat from us today and enjoy a reliable and enjoyable driving experience.",
    images: ["/__l5e/assets-v1/d05ce7ae-501f-4167-8ab8-23055cb3c273/volkswagen-passat-spacious-sedan-with-comfort-and-efficiency.png"],
    popularity: 75,
  },
  {
    id: 27,
    slug: "volkswagen-tiguan-versatile-suv-with-style-and-advanced-features",
    name: "Volkswagen Tiguan: Versatile SUV with Style and Advanced Features",
    brand: "Volkswagen",
    bodyType: "SUV",
    pricePerDay: 103,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2019,
    rating: 4.7,
    reviews: 34,
    location: MAIN_LOCATION,
    description: "The Volkswagen Tiguan combines modern design, advanced technology, and impressive versatility. With a spacious interior, smooth handling, and a comfortable ride, this SUV is perfect for both family trips and daily commutes. Rent the Volkswagen Tiguan from us today and experience premium comfort and performance.",
    images: ["/__l5e/assets-v1/d8a94db0-33c0-4c6d-96b7-f64e493ed36f/volkswagen-tiguan-versatile-suv-with-style-and-advanced-features.png"],
    popularity: 74,
  },
  {
    id: 28,
    slug: "volkswagen-touareg-premium-suv-with-luxurious-comfort",
    name: "Volkswagen Touareg: Premium SUV with Luxurious Comfort",
    brand: "Volkswagen",
    bodyType: "SUV",
    pricePerDay: 129,
    transmission: "Automatic",
    fuelType: "Diesel",
    drive: "Left",
    seats: 5,
    year: 2020,
    rating: 4.8,
    reviews: 41,
    location: MAIN_LOCATION,
    description: "The Volkswagen Touareg 2018 offers a blend of luxury, performance, and advanced technology. With its spacious interior, high-end features, and robust capabilities, this SUV is perfect for both city driving and off-road adventures. Rent the Volkswagen Touareg from us today and experience exceptional comfort and versatility.",
    images: ["/__l5e/assets-v1/11534621-f9d8-4bd3-8253-86521df060ef/volkswagen-touareg-premium-suv-with-luxurious-comfort.png"],
    popularity: 73,
  },
];

export const BRANDS = [...new Set(cars.map((c) => c.brand))].sort();
export const BODY_TYPES: BodyType[] = [
  "Compact",
  "Coupe",
  "Crossover",
  "Premium Selection",
  "Sedan",
  "SUV",
];
export const FUEL_TYPES: FuelType[] = ["CNG", "Diesel", "Electric", "Petrol"];
export const TRANSMISSIONS: Transmission[] = ["Automatic", "Manual", "Semi Automatic"];

export const getCarBySlug = (slug: string) => cars.find((c) => c.slug === slug);

export const formatPrice = (value: number) => `€${value} / Day`;

/**
 * Marketing name without the ": tagline" part, e.g. "BMW X1".
 */
export const getCarFullModel = (car: Car) => (car.name.split(":")[0] ?? car.name).trim();

/**
 * Model name without the brand prefix, e.g. "X1", "A4", "3 Series".
 */
export const getCarModel = (car: Car) => {
  const full = getCarFullModel(car);
  return full.toLowerCase().startsWith(car.brand.toLowerCase())
    ? full.slice(car.brand.length).trim() || full
    : full;
};

/**
 * Short spec fingerprint used to keep near-identical listings distinguishable
 * in titles, meta descriptions and structured data.
 */
export const getCarVariant = (car: Car) =>
  `${car.year} ${car.fuelType} ${car.transmission}`;
